export class TimelineItemTab {
  setLabel(value) {
    this.label = value;
    return this;
  }

  setSlotName(value) {
    this.slotName = value;
    return this;
  }

  setComponent(el) {
    this.component = el;
    return this;
  }

  addTab(el) {
    if (!this.tabs) this.tabs = [];
    this.tabs.push(el);
    return this;
  }
}

export class TimelineItem {
  setLabel(value) {
    this.label = value;
    return this;
  }

  setTagline(value) {
    this.tagline = value;
    return this;
  }

  addTab(el) {
    if (!this.tabs) this.tabs = [];
    this.tabs.push(el);
    return this;
  }
}
